import { Controller } from "@hotwired/stimulus";
import { openModal } from "../utils/misc";

export default class extends Controller {
  connect() {
    openModal(this.element.dataset.modalId);
  }
}
